import { Settings } from 'lucide-react';

type OwnProps = {
  onOpenPassengerTools: () => void;
};

export default function PassengerToolsButton({
  onOpenPassengerTools
}: OwnProps) {
  return (
    <div className="group m-md flex w-fit max-w-full items-center">
      <div className="bg-white opacity-0 transition-opacity duration-200 group-hover:opacity-90">
        <button
          type="button"
          onClick={onOpenPassengerTools}
          className="pointer-events-auto flex items-center gap-sm rounded-sm px-md py-sm text-gray-600 hover:text-gray-800"
          data-analytics-id="Passenger Tools"
          data-testid="passenger-tools"
          title="Passenger Tools"
        >
          <Settings size={12} /> Passenger
        </button>
      </div>
    </div>
  );
}
